<template lang="html">
  <div class="custom-manual-wrapper">
    <div v-for="input in getInputs" :key="input.name" class="inputs-wrapper">
      <div v-if="input.type === 'header'" class="header">
        {{ $t("main." + input.value) }}
      </div>
      <div v-else-if="input.type === 'description'" class="info wide">
        <span class="info-key"
          >*{{ $t("profile.purchase.rulesDescription") }}</span
        >
      </div>
      <div :class="{ spaced: input.type === 'switch' }" v-else class="info">
        <!-- <span class="info-key">
          {{ $t("profile.purchase." + input.name) }} :
        </span> -->
        <span v-if="input.type === 'text'" class="info-key">
          <TestInput
            v-model="input.value"
            :label="$t('profile.purchase.' + input.name)"
            @input="emitChange(input.name, $event)"
            type="text"
            :max-length="input.length"
          />
          <!-- <input
            :maxlength="input.length"
            type="text"
            @change="emitChange(input.name, $event.target.value)"
          /> -->
        </span>
        <span v-if="input.type === 'textarea'" class="info-key">
          <TestInput
            v-model="input.value"
            :label="$t('profile.purchase.' + input.name)"
            @input="emitChange(input.name, $event)"
            type="textarea"
            :max-length="input.length"
          />
          <!-- <input
            :maxlength="input.length"
            type="text"
            @change="emitChange(input.name, $event.target.value)"
          /> -->
        </span>
        <span
          v-else-if="input.type === 'checkbox'"
          class="info-key wrapp-checkbox"
        >
          <input
            type="checkbox"
            :id="input.name"
            @change="emitChange(input.name, $event.target.checked)"
          />
          <label :for="input.name">{{
            $t("profile.purchase." + input.name)
          }}</label>
          <questionmark
            v-if="input.questionmark"
            :id="input.questionmark"
            :tooltip="true"
          />
        </span>
        <span
          v-else-if="input.type === 'switch'"
          class="info-key wrapp-checkbox"
        >
          <input
            type="checkbox"
            :id="input.name"
            @change="
              emitChange('pro_individuals_trading', $event.target.checked)
            "
            v-model="otherRights2Condition"
          />
          <label :for="input.name">{{
            $t("profile.purchase." + input.name)
          }}</label>
        </span>
        <span
          v-else-if="input.type === 'dropdown' && input.name === 'rst_id'"
          class="info-key"
        >
          <dropdown
            :defaultText="$t('profile.purchase.rst_id')"
            :selected="input.value"
            :list="input.dropdownList"
            :removable="true"
            @remove="emitChange(input.name, null), (input.value = null)"
            @changeOption="
              emitChange(input.name, $event.value), (input.value = $event)
            "
          />
        </span>
        <span
          v-else-if="input.type === 'dropdown' && input.name !== 'rst_id'"
          class="info-key"
        >
          <dropdown
            :defaultText="$t('profile.purchase.choose')"
            :selected="input.value"
            :list="input.dropdownList"
            :removable="true"
            @remove="emitChange(input.name, null), (input.value = null)"
            @changeOption="
              emitChange(input.name, $event.value), (input.value = $event)
            "
          />
        </span>
        <questionmark
          v-if="input.questionmark && input.type != 'checkbox'"
          :id="input.questionmark"
          :tooltip="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Questionmark from "@/components/questionmark.vue";
import eventBus from "@/shared/eventBus.js";
import { api } from "@/api";
import Dropdown from "@/components/dropdown.vue";
import TestInput from "../shared/testInput.vue";
export default {
  name: "rightsInfo",
  components: {
    Dropdown,
    Questionmark,
    TestInput
  },
  props: {
    params: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      otherRights2Condition: false,
      inputs: [
        {
          type: "header",
          value: "quitSection"
        },
        {
          name: "pro_reject",
          type: "checkbox",
          questionmark: 47
        },
        {
          name: "pro_abandon",
          type: "checkbox",
          questionmark: 48
        },
        {
          name: "pro_abandon_no_offers",
          type: "checkbox",
          questionmark: 49
        },
        {
          name: "pro_limitations",
          value: "",
          type: "text",
          length: 1100,
          questionmark: 40
        },
        {
          type: "header",
          value: "responsibilitySection"
        },
        {
          name: "pro_jurisdiction",
          value: "",
          type: "text",
          length: 1100,
          questionmark: 38
        },
        {
          name: "rst_id",
          type: "dropdown",
          value: null,
          dropdownList: [],
          questionmark: 50
        },
        {
          type: "header",
          value: "otherRights"
        },
        {
          name: "pro_payment_info",
          value: "",
          type: "text",
          length: 1100,
          questionmark: 9
        },
        {
          name: "pro_deposit_info",
          value: "",
          type: "text",
          length: 1100,
          questionmark: 10
        },
        {
          name: "pro_contract_requirements",
          value: "",
          type: "text",
          length: 1100,
          questionmark: 11
        },
        {
          name: "pro_claims_responsibility",
          value: "",
          type: "text",
          length: 1100,
          questionmark: 12
        },
        {
          name: "pro_claims_info",
          value: "",
          type: "text",
          length: 1100,
          questionmark: 13
        },
        {
          name: "pro_warranty_info",
          value: "",
          type: "text",
          length: 1100,
          questionmark: 14
        },
        {
          name: "pro_warranty_address",
          value: "",
          type: "text",
          length: 1100,
          questionmark: 15
        },
        {
          name: "otherRights2Condition",
          type: "switch"
        },
        {
          type: "header",
          value: "otherRights2",
          condition: "otherRights2Condition"
        },
        {
          name: "pro_return_shipping_requirements",
          value: "",
          type: "textarea",
          length: 1100,
          condition: "otherRights2Condition"
        },
        {
          name: "pro_no_reject_condition",
          value: "",
          type: "textarea",
          length: 1100,
          condition: "otherRights2Condition"
        },
        {
          name: "pro_postal_info",
          value: "",
          type: "textarea",
          length: 1100,
          condition: "otherRights2Condition"
        },
        {
          name: "pro_return_shipping_cost",
          value: "",
          type: "textarea",
          length: 1100,
          condition: "otherRights2Condition"
        },
        {
          name: "pro_court_avoidance",
          value: "",
          type: "textarea",
          length: 1100,
          condition: "otherRights2Condition"
        },
        {
          name: "pro_rules",
          value: "",
          type: "textarea",
          length: 1100,
          condition: "otherRights2Condition"
        },
        {
          type: "description",
          condition: "otherRights2Condition"
        },
        {
          name: "pro_reject_rules",
          value: "",
          type: "textarea",
          length: 1100,
          condition: "otherRights2Condition"
        },
        {
          type: "description",
          condition: "otherRights2Condition"
        }
      ]
    };
  },
  mounted() {
    this.getRestrictions();
  },
  methods: {
    getRestrictions() {
      api
        .getRestrictions()
        .then(res => {
          for (var i = 0; i < this.inputs.length; i++) {
            if (this.inputs[i].name === "rst_id") {
              this.inputs[i].dropdownList = this.fixDropdownData(
                res.data.data,
                "restrictions"
              );
            }
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    fixDropdownData(data, type) {
      let res = [];
      if (type === "restrictions") {
        for (var i = 0; i < data.length; i++) {
          let obj = {
            label: data[i].rst_name,
            value: data[i].rst_id
          };
          res.push(obj);
        }
      }
      return res;
    },
    emitChange(key, value) {
      console.log(value);
      let data = {
        key: key,
        value: value
      };
      eventBus.$emit("changeNewAdParams", data);
    }
  },
  computed: {
    getInputs() {
      let res = [];
      for (var i = 0; i < this.inputs.length; i++) {
        if (
          this.inputs[i].condition &&
          this.inputs[i].condition === "otherRights2Condition" &&
          !this.otherRights2Condition
        ) {
        } else {
          res.push(this.inputs[i]);
        }
      }
      return res;
    }
  },
  watch: {
    "$route.params.lang": {
      handler: function() {
        this.getRestrictions();
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
input {
  height: 40px;
  border: 1px solid #e8e8e8;
  padding-left: 5px;
}
input:focus {
  outline: none;
}
.custom-manual-wrapper {
  // padding: 20px;
  // width: 100%;
  // display: flex;
  // flex-direction: column;
  // border: 1px solid rgba(243, 243, 243, 0.5);
  // box-sizing: border-box;
  // box-shadow: 0px 4px 7px rgba(0, 0, 0, 0.08);
  text-align: left;
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  @import "@/assets/scss/btnStyles.scss";

  .header {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0%;

    // border-bottom: 1px solid $main-color;
    color: $blue-1000;
    margin-bottom: 20px;
  }
  .line {
    margin: 0 0 30px 0;
    border-bottom: 1px solid $gray-blue-700;
  }
  .info.wide {
    margin-top: -25px;

    .info-key {
      width: 100%;
    }
  }
  .info.spaced {
    margin-top: 25px;
  }
  .info {
    margin-bottom: 25px;
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: left;
    flex-wrap: wrap;

    .info-key {
      font-weight: 400;
      font-style: Regular;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0%;
      color: $blue-400;

      // white-space: nowrap;
      // min-width: 150px;
      max-width: 100%;
      width: 582px;
      label {
        cursor: pointer;
      }
    }
    .info-key.wrapp-checkbox {
      font-size: 14px;

      display: flex;
      align-items: center;
      width: 610px;
    }
    .info-value {
      font-weight: 800;
      font-size: 13px;
      line-height: 21px;
      letter-spacing: 0.02em;
      color: $text-color;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      flex-grow: 1;
      justify-content: flex-start;

      input[type="text"] {
        width: 100%;
      }

      input[type="file"] {
        height: auto;
        border: none;
      }

      input[type="checkbox"] {
        margin-left: auto;
      }

      textarea {
        width: 100%;
        border: 1px solid #dfdfdf;
        outline: none;
        resize: none;
        margin-top: 5px;
      }
    }
    .info-value.wide {
      width: 100%;
    }
    .info-value.prices {
      display: flex;
      flex-direction: row;
      align-items: center;
      * {
        margin-right: 10px;
      }
      input {
        width: 60px;
      }
      .btn {
        width: 100px;
      }
    }
  }
}
</style>
